"use strict";

// Step2「チーム分け」画面のJS
// DOM id 契約:
//   config div: #team-assign-config[data-config]
//   #progressFill
//   #poolChips, #poolEmpty, #poolHint, #poolCountNote
//   #teamCards, #addTeamBtn, #addTeamHint, #specialCards, .roles-divider
//   #barNote, #barNoteText, #barBack, #barNext, #barNextText
//   シート: #teamChoiceOverlay/#teamChoiceTitle/#teamChoiceList
//           #memberPickOverlay/#memberPickList/#memberPickConfirm
//   form id=assignment-form

(function () {
  // ===== 定数 =====
  var DEFAULT_TEAM_COLORS = [
    "#C62828",
    "#1565C0",
    "#2E7D32",
    "#EF6C00",
    "#6A1B9A",
    "#00838F",
    "#D84315",
    "#546E7A",
    "#AD1457",
    "#4527A0",
    "#0277BD",
    "#558B2F",
    "#9E7C0C",
    "#4E342E",
    "#33404F",
    "#8E3A59",
    "#5E4B9B",
    "#2D6B63",
    "#A04B16",
    "#5D621A",
  ];

  var SPECIAL_ROLES = {
    kuroko: {
      label: "",
      color: "#33404F",
      shortDesc: "",
      desc: "",
    },
    recorder: {
      label: "",
      color: "#0277BD",
      shortDesc: "",
      desc: "",
    },
  };

  // i18n はモジュールスコープで宣言し、init() で dataset.i18n を解析して代入する
  var i18n = {};

  // ===== 状態 =====
  var config = null;
  var icons = {};
  var players = []; // [{ id, name, hasAccount, role, hasMatch }]（ページロード時の全メンバー）
  var teams = []; // [{ name, color, existingTeamId, playerIds }]
  var assignments = {}; // playerId -> teamIdx(number) | 'kuroko' | 'recorder'

  var pickTarget = null; // { type: 'team', idx } | { type: 'role', key }
  var pickSelectedIds = new Set();
  var choiceTargetPlayer = null;

  // sessionStorage キー（init 後に確定）
  var STORAGE_KEY = null;

  // ===== ユーティリティ =====
  function esc(str) {
    return JanrecoUtils.escapeHtml(String(str));
  }

  function el(id) {
    return document.getElementById(id);
  }

  function showToast(msg, type) {
    window.TeamUiShared.showToast(msg, type);
  }

  function openSheet(id) {
    window.TeamUiShared.openSheet(id);
  }

  function closeSheet(id) {
    window.TeamUiShared.closeSheet(id);
  }

  function hasMatchRecords(pid) {
    var p = findPlayer(pid);
    return p ? !!p.hasMatch : false;
  }

  function findPlayer(pid) {
    var pidNum = Number(pid);
    for (var i = 0; i < players.length; i++) {
      if (players[i].id === pidNum) return players[i];
    }
    return null;
  }

  // ===== チーム数管理 =====
  function ensureTeams(n) {
    var presetColors = (config && config.presetColors) || DEFAULT_TEAM_COLORS;
    while (teams.length < n) {
      var i = teams.length;
      teams.push({
        existingTeamId: null,
        name: (i18n.defaultTeamName || '').replace('%{num}', i + 1),
        color: presetColors[i % presetColors.length],
        playerIds: [],
      });
    }
    if (teams.length > n) {
      // 削減時: 削減分のteamIdxに割り当てられていたプレイヤーをプールに戻す
      Object.keys(assignments).forEach(function (pidStr) {
        var v = assignments[pidStr];
        if (typeof v === "number" && v >= n) {
          delete assignments[pidStr];
        }
      });
      teams.length = n;
    }
  }

  // ===== データヘルパー =====
  function poolPlayers() {
    return players.filter(function (p) {
      return assignments[p.id] === undefined;
    });
  }

  function teamMembers(idx) {
    return players.filter(function (p) {
      return assignments[p.id] === idx;
    });
  }

  function roleMembers(key) {
    return players.filter(function (p) {
      return assignments[p.id] === key;
    });
  }

  function assignedCount() {
    return players.filter(function (p) {
      return assignments[p.id] !== undefined;
    }).length;
  }

  function teamTotalCount() {
    return players.filter(function (p) {
      return typeof assignments[p.id] === "number";
    }).length;
  }

  function destInfo(target) {
    if (target.type === "team") {
      var t = teams[target.idx];
      return {
        name: t ? t.name || (i18n.defaultTeamName || '').replace('%{num}', target.idx + 1) : i18n.teamFallback,
        color: t ? t.color : "#666",
      };
    }
    var r = SPECIAL_ROLES[target.key];
    return r
      ? { name: r.label, color: r.color }
      : { name: target.key, color: "#666" };
  }

  function assignValue(target) {
    return target.type === "team" ? target.idx : target.key;
  }

  // ===== 振り分け未完了プール描画 =====
  function renderPool() {
    var wrap = el("poolChips");
    var emptyEl = el("poolEmpty");
    var hintEl = el("poolHint");
    var countNoteEl = el("poolCountNote");
    if (!wrap) return;

    wrap.innerHTML = "";
    var pool = poolPlayers();

    pool.forEach(function (p) {
      var chip = document.createElement("button");
      chip.type = "button";
      chip.className = "pool-chip";
      chip.innerHTML =
        '<span class="chip-avatar">' +
        esc(p.name.charAt(0)) +
        "</span>" +
        esc(p.name) +
        icons.poolPlus;
      chip.addEventListener("click", function () {
        openTeamChoice(p);
      });
      wrap.appendChild(chip);
    });

    if (emptyEl) emptyEl.classList.toggle("show", pool.length === 0);
    if (hintEl) hintEl.style.display = pool.length === 0 ? "none" : "";
    if (countNoteEl) countNoteEl.textContent = window.Janreco.pluralize(i18n.poolCount, pool.length);
  }

  // チーム名入力欄の幅を中身に合わせて実測調整する（全角・半角どちらも正確、編集余白込み）
  function fitNameInput(inp) {
    if (!inp) return;
    var span = document.createElement("span");
    var cs = window.getComputedStyle(inp);
    span.style.position = "absolute";
    span.style.top = "-9999px";
    span.style.left = "-9999px";
    span.style.visibility = "hidden";
    span.style.whiteSpace = "pre";
    span.style.fontSize = cs.fontSize;
    span.style.fontFamily = cs.fontFamily;
    span.style.fontWeight = cs.fontWeight;
    span.style.letterSpacing = cs.letterSpacing;
    span.textContent = inp.value || "";
    document.body.appendChild(span);
    var textWidth = span.getBoundingClientRect().width;
    document.body.removeChild(span);
    // input の左右padding + 編集用の余白 + カーソル分を加味し、上下限でクランプ
    var width = Math.min(Math.max(textWidth + 28, 64), 240);
    inp.style.width = width + "px";
  }

  // ===== チームカード群描画 =====
  function renderTeamCards() {
    var wrap = el("teamCards");
    if (!wrap) return;

    wrap.innerHTML = "";
    teams.forEach(function (t, idx) {
      var members = teamMembers(idx);
      var card = document.createElement("section");
      card.className = "team-card";

      var tintColor = t.color;
      var membersChipsHtml = members
        .map(function (m) {
          var canRemove = !hasMatchRecords(m.id);
          var xBtn = canRemove
            ? '<button type="button" class="chip-x" data-pid="' +
              m.id +
              '" aria-label="' +
              (i18n.resetToPoolAria || '').replace('%{name}', esc(m.name)) +
              '">' +
              icons.chipX +
              "</button>"
            : "";
          return (
            '<span class="tc-member-chip">' +
            '<span class="chip-avatar" style="background:' +
            tintColor +
            '">' +
            esc(m.name.charAt(0)) +
            "</span>" +
            esc(m.name) +
            xBtn +
            "</span>"
          );
        })
        .join("");

      var playType = config ? config.playType || 4 : 4;
      var canDelete =
        teams.length > playType &&
        !members.some(function (m) {
          return hasMatchRecords(m.id);
        });
      var deleteBtnHtml = canDelete
        ? '<button type="button" class="tc-delete-btn" data-idx="' +
          idx +
          '" aria-label="' +
          (i18n.removeAria || '').replace('%{name}', esc(t.name || i18n.teamFallback)) +
          '">' +
          icons.deleteTeam +
          "</button>"
        : "";

      card.innerHTML =
        '<div class="tc-band" style="background:' +
        tintColor +
        '"></div>' +
        '<div class="tc-header" style="background:color-mix(in srgb,' +
        tintColor +
        ' 7%,white)">' +
        '<button type="button" class="tc-color-btn" data-idx="' +
        idx +
        '" style="background:' +
        tintColor +
        '" aria-label="' + i18n.changeColorAria + '">' +
        esc((t.name || "？").charAt(0)) +
        '<span class="edit-mark">' +
        icons.editMark +
        "</span>" +
        "</button>" +
        '<div class="tc-name-wrap">' +
        '<input type="text" class="tc-name-input" data-idx="' +
        idx +
        '" value="' +
        esc(t.name) +
        '" maxlength="15" aria-label="' + i18n.fieldTeamName + '">' +
        '<button type="button" class="tc-name-edit-btn" data-idx="' +
        idx +
        '" aria-label="' + i18n.editNameAria + '">' +
        icons.editBtn +
        "</button>" +
        "</div>" +
        '<span class="tc-count' +
        (members.length === 0 ? " warn" : "") +
        '">' +
        members.length +
        esc(i18n.memberCountUnit) + "</span>" +
        deleteBtnHtml +
        "</div>" +
        '<div class="tc-members">' +
        membersChipsHtml +
        '<button type="button" class="tc-add-chip" data-target=\'{"type":"team","idx":' +
        idx +
        "}'>" +
        icons.addChip +
        esc(i18n.addLabel) +
        "</button>" +
        "</div>";

      wrap.appendChild(card);
    });

    // チームカードのイベントをバインド
    bindTeamCardEvents();
  }

  // ===== 特別枠カード群描画 =====
  function renderSpecialCards() {
    var wrap = el("specialCards");
    if (!wrap) return;

    wrap.innerHTML = "";
    Object.keys(SPECIAL_ROLES).forEach(function (key) {
      var role = SPECIAL_ROLES[key];
      var members = roleMembers(key);
      var card = document.createElement("section");
      card.className = "special-card";

      var membersChipsHtml = members
        .map(function (m) {
          var canRemove = !hasMatchRecords(m.id);
          var xBtn = canRemove
            ? '<button type="button" class="chip-x" data-pid="' +
              m.id +
              '" aria-label="' +
              (i18n.resetToPoolAria || '').replace('%{name}', esc(m.name)) +
              '">' +
              icons.chipX +
              "</button>"
            : "";
          return (
            '<span class="tc-member-chip">' +
            '<span class="chip-avatar" style="background:' +
            role.color +
            '">' +
            esc(m.name.charAt(0)) +
            "</span>" +
            esc(m.name) +
            xBtn +
            "</span>"
          );
        })
        .join("");

      card.innerHTML =
        '<div class="tc-header">' +
        '<span class="special-icon" style="background:' +
        role.color +
        '">' +
        (icons[key] || "") +
        "</span>" +
        '<div class="special-title">' +
        '<div class="special-name">' +
        esc(role.label) +
        "</div>" +
        '<div class="special-desc">' +
        esc(role.shortDesc) +
        "</div>" +
        "</div>" +
        '<span class="tc-count">' +
        members.length +
        esc(i18n.memberCountUnit) + "</span>" +
        "</div>" +
        '<div class="tc-members">' +
        membersChipsHtml +
        '<button type="button" class="tc-add-chip" data-target=\'{"type":"role","key":"' +
        key +
        "\"}'>" +
        icons.addChip +
        esc(i18n.addLabel) +
        "</button>" +
        "</div>";

      wrap.appendChild(card);
    });

    // 特別枠カードの chip-x / tc-add-chip にイベントをバインド
    bindChipEvents(wrap);
  }

  // ===== チーム削除 =====
  function deleteTeam(idx) {
    var playType = config ? config.playType || 4 : 4;
    if (teams.length <= playType) {
      showToast(window.Janreco.pluralize(i18n.needTeams, playType), "warn");
      return;
    }
    var members = teamMembers(idx);
    var hasRecord = members.some(function (m) {
      return hasMatchRecords(m.id);
    });
    if (hasRecord) {
      showToast(i18n.cannotDeleteWithRecords, "warn");
      return;
    }
    // assignments を再マッピング
    Object.keys(assignments).forEach(function (pidStr) {
      var v = assignments[pidStr];
      if (typeof v !== "number") return;
      if (v === idx) {
        delete assignments[pidStr];
      } else if (v > idx) {
        assignments[pidStr] = v - 1;
      }
    });
    teams.splice(idx, 1);
    renderStep2();
  }

  // ===== イベントバインド：チームカード =====
  function bindTeamCardEvents() {
    var teamCardsEl = el("teamCards");
    if (!teamCardsEl) return;

    // チーム名入力（入力欄の幅を中身に合わせて実測追従）
    teamCardsEl.querySelectorAll(".tc-name-input").forEach(function (inp) {
      fitNameInput(inp);
      inp.addEventListener("input", function () {
        var idx = parseInt(inp.dataset.idx, 10);
        teams[idx].name = inp.value;
        // カラーボタンの頭文字を更新
        var colorBtn = inp.closest(".tc-header").querySelector(".tc-color-btn");
        if (colorBtn) {
          colorBtn.childNodes[0].textContent = (inp.value || "？").charAt(0);
        }
        fitNameInput(inp);
        updateBar();
      });
    });

    // チーム名編集ボタン（クリックで入力欄にフォーカス）
    teamCardsEl.querySelectorAll(".tc-name-edit-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var inp = btn.parentNode.querySelector(".tc-name-input");
        if (inp) {
          inp.focus();
          inp.select();
        }
      });
    });

    // チームカラーボタン
    teamCardsEl.querySelectorAll(".tc-color-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        openColorPick(parseInt(btn.dataset.idx, 10));
      });
    });

    // チーム削除ボタン
    teamCardsEl.querySelectorAll(".tc-delete-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.dataset.idx, 10);
        deleteTeam(idx);
      });
    });

    // chip-x / tc-add-chip
    bindChipEvents(teamCardsEl);
  }

  // ===== イベントバインド：チップ共通 =====
  function bindChipEvents(scope) {
    // メンバーをプールに戻す（×ボタン）
    scope.querySelectorAll(".chip-x").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var pid = Number(btn.dataset.pid);
        if (hasMatchRecords(pid)) return; // 対局成績ありは移動不可
        delete assignments[pid];
        renderStep2();
      });
    });

    // メンバー複数選択シートを開く（+追加ボタン）
    scope.querySelectorAll(".tc-add-chip").forEach(function (btn) {
      btn.addEventListener("click", function () {
        try {
          var target = JSON.parse(btn.dataset.target);
          openMemberPick(target);
        } catch (e) {
          console.error("tc-add-chip data-target parse error:", e);
        }
      });
    });
  }

  // ===== 振り分け先選択シート（プール起点）=====
  function openTeamChoice(player) {
    choiceTargetPlayer = player;
    var titleEl = el("teamChoiceTitle");
    if (titleEl) titleEl.textContent = (i18n.choiceTitleFor || '').replace('%{name}', player.name);

    var list = el("teamChoiceList");
    if (!list) return;
    list.innerHTML = "";

    // チーム行
    teams.forEach(function (t, idx) {
      var row = document.createElement("div");
      row.className = "team-choice-row";
      row.innerHTML =
        '<span class="team-choice-dot" style="background:' +
        t.color +
        '">' +
        esc((t.name || "？").charAt(0)) +
        "</span>" +
        '<div class="team-choice-main"><div class="team-choice-name">' +
        esc(t.name || (i18n.defaultTeamName || '').replace('%{num}', idx + 1)) +
        "</div></div>" +
        '<span class="team-choice-count">' +
        teamMembers(idx).length +
        esc(i18n.memberCountUnit) + "</span>";
      row.addEventListener("click", function () {
        assignPlayer(player, { type: "team", idx: idx });
      });
      list.appendChild(row);
    });

    // 区切り
    var divider = document.createElement("div");
    divider.className = "choice-divider";
    divider.textContent = i18n.noTeamDivider;
    list.appendChild(divider);

    // 特別枠行
    Object.keys(SPECIAL_ROLES).forEach(function (key) {
      var r = SPECIAL_ROLES[key];
      var row = document.createElement("div");
      var isRecorder = key === "recorder";
      var isDisabled = isRecorder && !player.hasAccount;

      row.className = "team-choice-row" + (isDisabled ? " disabled" : "");

      var noteText = "";
      if (isRecorder) {
        if (isDisabled) {
          noteText = i18n.notRegistered;
        } else {
          noteText = i18n.accountRequired;
        }
      }

      var noteHtml = isRecorder
        ? '<div class="team-choice-note">' + esc(noteText) + "</div>"
        : "";

      row.innerHTML =
        '<span class="team-choice-dot" style="background:' +
        r.color +
        '">' +
        (icons[key] || "") +
        "</span>" +
        '<div class="team-choice-main">' +
        '<div class="team-choice-name">' +
        esc(r.label) +
        "</div>" +
        '<div class="team-choice-desc">' +
        esc(r.desc) +
        "</div>" +
        noteHtml +
        "</div>" +
        '<span class="team-choice-count">' +
        roleMembers(key).length +
        esc(i18n.memberCountUnit) + "</span>";

      if (!isDisabled) {
        row.addEventListener("click", function () {
          assignPlayer(player, { type: "role", key: key });
        });
      }
      list.appendChild(row);
    });

    openSheet("teamChoiceOverlay");
  }

  function assignPlayer(player, target) {
    assignments[player.id] = assignValue(target);
    closeSheet("teamChoiceOverlay");
    renderStep2();
    showToast(
      (i18n.addedToDest || '')
        .replace('%{player}', player.name)
        .replace('%{dest}', destInfo(target).name)
    );
  }

  // ===== メンバー複数選択シート（カード起点）=====
  function openMemberPick(target) {
    pickTarget = target;
    pickSelectedIds = new Set();

    var titleEl = el("memberPickTitle");
    if (titleEl)
      titleEl.textContent = (i18n.addMemberTo || '').replace('%{dest}', destInfo(target).name);

    renderMemberPick();
    openSheet("memberPickOverlay");
  }

  function renderMemberPick() {
    var list = el("memberPickList");
    if (!list) return;
    list.innerHTML = "";

    var isRecorderTarget =
      pickTarget && pickTarget.type === "role" && pickTarget.key === "recorder";

    // 記録専門への追加の場合、補足ノートを表示
    if (isRecorderTarget) {
      var note = document.createElement("p");
      note.className = "member-pick-note";
      note.textContent = i18n.recordOnlyAccountRequired;
      list.appendChild(note);
    }

    var pool = poolPlayers();
    if (pool.length === 0) {
      var empty = document.createElement("p");
      empty.style.cssText =
        "font-size:13px;color:var(--text-muted,#97A2AD);padding:8px 0";
      empty.textContent = i18n.poolEmptyMembers;
      list.appendChild(empty);
    }

    pool.forEach(function (p) {
      var isDisabledRow = isRecorderTarget && !p.hasAccount;
      var row = document.createElement("div");
      row.className =
        "candidate-row" +
        (pickSelectedIds.has(p.id) ? " selected" : "") +
        (isDisabledRow ? " disabled" : "");
      row.innerHTML =
        '<span class="candidate-check">' +
        icons.check +
        "</span>" +
        '<span class="candidate-name">' +
        esc(p.name) +
        "</span>";
      if (!isDisabledRow) {
        row.addEventListener("click", function () {
          if (pickSelectedIds.has(p.id)) {
            pickSelectedIds.delete(p.id);
          } else {
            pickSelectedIds.add(p.id);
          }
          renderMemberPick();
        });
      }
      list.appendChild(row);
    });

    var n = pickSelectedIds.size;
    var confirmBtn = el("memberPickConfirm");
    if (confirmBtn) {
      confirmBtn.disabled = n === 0;
      confirmBtn.textContent = window.Janreco.pluralize(i18n.addCount, n);
    }
  }

  // ===== カラー選択シート（teamChoiceOverlay を流用・ネイティブピッカー）=====
  var colorTargetIdx = null;

  function openColorPick(idx) {
    colorTargetIdx = idx;
    var t = teams[idx];
    var titleEl = el("teamChoiceTitle");
    if (titleEl) titleEl.textContent = (i18n.colorFor || '').replace('%{name}', t.name || i18n.teamFallback);

    var list = el("teamChoiceList");
    if (!list) return;

    var currentHex = (t.color || "#C62828").toUpperCase();

    list.innerHTML =
      '<div class="color-picker-wrap">' +
      '<input type="color" id="colorPickerInput" class="color-picker-native" value="' +
      currentHex +
      '">' +
      '<div class="color-picker-preview-row">' +
      '<span class="color-picker-swatch" id="colorPickerSwatch" style="background:' +
      currentHex +
      '"></span>' +
      '<span class="color-picker-hex" id="colorPickerHex">' +
      currentHex +
      "</span>" +
      "</div>" +
      '<p class="color-picker-warn" id="colorPickerWarn" style="display:none">' +
      esc(i18n.contrastTooLight) +
      "</p>" +
      '<button type="button" class="color-picker-confirm btn-primary" id="colorPickerConfirm">' + esc(i18n.setThisColor) + '</button>' +
      "</div>";

    var inputEl = list.querySelector("#colorPickerInput");
    var swatchEl = list.querySelector("#colorPickerSwatch");
    var hexEl = list.querySelector("#colorPickerHex");
    var warnEl = list.querySelector("#colorPickerWarn");
    var confirmBtn = list.querySelector("#colorPickerConfirm");

    function validateAndUpdate(hex) {
      swatchEl.style.background = hex;
      hexEl.textContent = hex;
      var sufficient = window.TeamColorContrast
        ? window.TeamColorContrast.isSufficient(hex)
        : true;
      if (sufficient) {
        warnEl.style.display = "none";
        confirmBtn.disabled = false;
      } else {
        warnEl.style.display = "";
        confirmBtn.disabled = true;
      }
    }

    // 初期バリデーション
    validateAndUpdate(currentHex);

    inputEl.addEventListener("input", function () {
      validateAndUpdate(inputEl.value.toUpperCase());
    });

    confirmBtn.addEventListener("click", function () {
      var hex = inputEl.value.toUpperCase();
      var sufficient = window.TeamColorContrast
        ? window.TeamColorContrast.isSufficient(hex)
        : true;
      if (!sufficient) return;
      teams[colorTargetIdx].color = hex;
      closeSheet("teamChoiceOverlay");
      renderStep2();
    });

    openSheet("teamChoiceOverlay");
  }

  // ===== 進捗バー＋バリデーション =====
  function updateBar() {
    var noteEl = el("barNote");
    var noteTextEl = el("barNoteText");
    var nextBtn = el("barNext");
    if (!noteEl || !noteTextEl || !nextBtn) return;

    var assigned = assignedCount();
    var total = players.length;
    var playType = config ? config.playType || 4 : 4;

    // 進捗バー更新（save-bar内の細いバー）
    var progressFillEl = el("progressFill");
    if (progressFillEl) {
      progressFillEl.style.width =
        total === 0 ? "0%" : (assigned / total) * 100 + "%";
    }

    var pool = total - assigned;
    var emptyTeams = teams.filter(function (t, i) {
      return teamMembers(i).length === 0;
    }).length;
    var emptyNames = teams.some(function (t) {
      return !t.name.trim();
    });
    var tTotal = teamTotalCount();
    var ok = false;

    var svgEl = noteEl.querySelector("svg");

    if (teams.length === 0) {
      noteTextEl.textContent = i18n.barAdd;
    } else if (pool > 0) {
      noteTextEl.textContent = window.Janreco.pluralize(i18n.barUnassigned, pool);
    } else if (tTotal < playType) {
      noteTextEl.textContent =
        (i18n.barNeedMembers || '')
          .replace('%{needed}', playType)
          .replace('%{current}', tTotal);
    } else if (emptyTeams > 0) {
      noteTextEl.textContent =
        window.Janreco.pluralize(i18n.barEmptyTeams, emptyTeams);
    } else if (emptyNames) {
      noteTextEl.textContent = i18n.toastNameMissing;
    } else {
      ok = true;
      noteTextEl.textContent = i18n.barOk;
    }

    noteEl.classList.toggle("ok", ok);
    if (svgEl) svgEl.style.display = ok ? "none" : "";
    nextBtn.disabled = !ok;
  }

  // ===== チーム上限ヒント更新 =====
  function updateAddTeamHint() {
    var hintEl = el("addTeamHint");
    if (!hintEl) return;

    var teamLimit = config ? config.teamLimit || 20 : 20;
    if (teams.length >= teamLimit) {
      hintEl.classList.add("is-max");
      hintEl.textContent =
        window.Janreco.pluralize(i18n.barTeamLimit, teamLimit);
    } else {
      hintEl.classList.remove("is-max");
      hintEl.textContent =
        (i18n.barMaxTeams || '')
          .replace('%{max}', teamLimit)
          .replace('%{current}', teams.length);
    }
  }

  // ===== sessionStorage 保存 =====
  function persistState() {
    if (!config || !window.sessionStorage) return;
    try {
      var payload = {
        teams: teams.map(function (t) {
          return {
            existingTeamId: t.existingTeamId || null,
            name: t.name,
            color: t.color,
          };
        }),
        assignments: assignments,
      };
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      /* QuotaExceeded等は無視 */
    }
  }

  // ===== sessionStorage 復元 =====
  // 戻り値: true=復元成功、false=フォールバックが必要
  function restoreState() {
    if (!window.sessionStorage || !STORAGE_KEY) return false;

    var raw;
    try {
      raw = window.sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return false;
    }

    if (!raw) return false;

    var payload;
    try {
      payload = JSON.parse(raw);
    } catch (e) {
      return false;
    }

    // 安全ガード: 基本構造チェック
    if (
      !Array.isArray(payload.teams) ||
      typeof payload.assignments !== "object" ||
      payload.assignments === null
    ) {
      return false;
    }

    // 安全ガード: 既存チームの構成が DB と食い違う場合はフォールバック
    // （一括情報編集でチームを追加・削除した後に古い状態を使うと、振り分けがずれるため）
    var dbTeamsById = {};
    (config.existingTeams || []).forEach(function (t) {
      dbTeamsById[String(t.id)] = t;
    });
    var savedExistingIds = payload.teams
      .map(function (t) {
        return t && t.existingTeamId ? String(t.existingTeamId) : null;
      })
      .filter(function (id) {
        return id !== null;
      });
    var dbIds = Object.keys(dbTeamsById);
    var sameTeams =
      savedExistingIds.length === dbIds.length &&
      savedExistingIds.every(function (id) {
        return Object.prototype.hasOwnProperty.call(dbTeamsById, id);
      }) &&
      new Set(savedExistingIds).size === savedExistingIds.length;
    if (!sameTeams) return false;

    // teams を復元（既存チームの名前・カラーは DB の値を使う）
    var restoredTeams = payload.teams.map(function (t) {
      var dbTeam = t.existingTeamId ? dbTeamsById[String(t.existingTeamId)] : null;
      return {
        existingTeamId: t.existingTeamId || null,
        name: dbTeam ? dbTeam.name : t.name || "",
        color: dbTeam ? dbTeam.color : t.color || "#C62828",
        playerIds: [],
      };
    });

    // assignments を復元（整合チェック付き）
    var restoredAssignments = {};
    Object.keys(payload.assignments).forEach(function (pidStr) {
      var v = payload.assignments[pidStr];
      var pidNum = Number(pidStr);

      // 現在の players に存在しない playerId は破棄
      if (!findPlayer(pidNum)) return;

      if (typeof v === "number") {
        // teamIdx が復元した teams の範囲内のもののみ採用
        if (v >= 0 && v < restoredTeams.length) {
          restoredAssignments[pidNum] = v;
        }
        // 範囲外はプールに戻す（何もしない）
      } else if (v === "kuroko" || v === "recorder") {
        restoredAssignments[pidNum] = v;
      }
    });

    // 安全ガード: hasMatch===true のプレイヤーがプールに残る場合はフォールバック
    var hasUnassignedWithMatch = players.some(function (p) {
      return !!p.hasMatch && restoredAssignments[p.id] === undefined;
    });
    if (hasUnassignedWithMatch) return false;

    // 復元成功
    teams = restoredTeams;
    assignments = restoredAssignments;
    return true;
  }

  // ===== Step2 全体再描画 =====
  function renderStep2() {
    renderPool();
    renderTeamCards();
    renderSpecialCards();
    updateBar();
    updateAddTeamHint();
    persistState();
  }

  // ===== submit 直前に hidden input を構築 =====
  // B → POST saveAssignmentUrl（form=assignment-form）
  // - teams[0][name], teams[0][color], teams[0][existing_team_id], teams[0][player_ids][]
  //   teams[1][name], ... （ハッシュ形式 index 連番）
  // - kuroko_player_ids[]
  // - recorder_player_ids[]
  function buildHiddenInputs() {
    var form = document.getElementById("assignment-form");
    if (!form) return;

    // 前回の注入分をクリア
    form.querySelectorAll(".js-hidden-submit").forEach(function (inp) {
      inp.parentNode.removeChild(inp);
    });

    function addHidden(name, value) {
      var inp = document.createElement("input");
      inp.type = "hidden";
      inp.name = name;
      inp.value = value;
      inp.className = "js-hidden-submit";
      form.appendChild(inp);
    }

    // teams ハッシュ形式
    teams.forEach(function (t, i) {
      addHidden("teams[" + i + "][name]", t.name);
      addHidden("teams[" + i + "][color]", t.color);
      if (t.existingTeamId) {
        addHidden("teams[" + i + "][existing_team_id]", t.existingTeamId);
      }
      var members = teamMembers(i);
      members.forEach(function (m) {
        addHidden("teams[" + i + "][player_ids][]", m.id);
      });
    });

    // 黒子
    roleMembers("kuroko").forEach(function (m) {
      addHidden("kuroko_player_ids[]", m.id);
    });

    // 記録専門
    roleMembers("recorder").forEach(function (m) {
      addHidden("recorder_player_ids[]", m.id);
    });
  }

  // ===== 既存チームから初期振り分けを構築 =====
  function initAssignmentsFromExisting() {
    var existingTeams = config.existingTeams || [];
    if (existingTeams.length === 0) {
      // 既存チームなし: role設定済みプレイヤーを特別枠に初期配置
      players.forEach(function (p) {
        if (p.role === "kuroko") {
          assignments[p.id] = "kuroko";
        } else if (p.role === "record_only") {
          assignments[p.id] = "recorder";
        }
        // regularはプールに残す
      });
      return;
    }

    // 既存チームを teams 配列に復元
    teams = existingTeams.map(function (t) {
      return {
        existingTeamId: t.id,
        name: t.name,
        color: t.color,
        playerIds: (t.playerIds || []).slice(),
      };
    });

    // assignments を構築
    existingTeams.forEach(function (t, idx) {
      (t.playerIds || []).forEach(function (pid) {
        assignments[pid] = idx;
      });
    });

    // role設定済みプレイヤーを特別枠に初期配置（チームに所属していないもの）
    players.forEach(function (p) {
      if (assignments[p.id] !== undefined) return;
      if (p.role === "kuroko") {
        assignments[p.id] = "kuroko";
      } else if (p.role === "record_only") {
        assignments[p.id] = "recorder";
      }
    });
  }

  // ===== 初期化 =====
  function init() {
    var configEl = el("team-assign-config");
    if (!configEl) return; // このページ以外では起動しない

    try {
      config = JSON.parse(configEl.dataset.config);
      icons = JSON.parse(configEl.dataset.icons || "{}");
      i18n = JSON.parse(configEl.dataset.i18n || "{}");
    } catch (e) {
      console.error("assignment config の parse に失敗:", e);
      return;
    }

    // SPECIAL_ROLES のラベル・説明を i18n で上書き（定義時は ja フォールバック値）
    SPECIAL_ROLES.kuroko.label = i18n.kurokoLabel || SPECIAL_ROLES.kuroko.label;
    SPECIAL_ROLES.kuroko.shortDesc = i18n.kurokoShortDesc || SPECIAL_ROLES.kuroko.shortDesc;
    SPECIAL_ROLES.kuroko.desc = i18n.kurokoDesc || SPECIAL_ROLES.kuroko.desc;
    SPECIAL_ROLES.recorder.label = i18n.recorderLabel || SPECIAL_ROLES.recorder.label;
    SPECIAL_ROLES.recorder.shortDesc = i18n.recorderShortDesc || SPECIAL_ROLES.recorder.shortDesc;
    SPECIAL_ROLES.recorder.desc = i18n.recorderDesc || SPECIAL_ROLES.recorder.desc;

    // sessionStorage キーを確定
    STORAGE_KEY = "janreco_team_assign_v1_" + (config.leagueId || "x");

    // 状態リセット（players は先にリセット）
    players = (config.players || []).map(function (p) {
      return {
        id: p.id,
        name: p.name,
        hasAccount: !!p.hasAccount,
        role: p.role || "regular",
        hasMatch: !!p.hasMatch,
      };
    });
    teams = [];
    assignments = {};
    pickTarget = null;
    pickSelectedIds = new Set();
    choiceTargetPlayer = null;
    colorTargetIdx = null;

    // sessionStorage から復元を試みる。失敗したら従来の初期化へ
    var restored = restoreState();
    if (!restored) {
      // 既存チーム/ロール設定から初期振り分けを構築
      initAssignmentsFromExisting();
    }

    // チーム数が playType 未満なら playType に引き上げ（復元経路でも実行）
    var playType = config.playType || 4;
    if (teams.length < playType) {
      ensureTeams(playType);
    }

    // addTeamBtn：＋チーム追加ボタン
    var addTeamBtn = el("addTeamBtn");
    if (addTeamBtn) {
      addTeamBtn.addEventListener("click", function () {
        var teamLimit = config ? config.teamLimit || 20 : 20;
        if (teams.length >= teamLimit) {
          showToast(window.Janreco.pluralize(i18n.teamLimitShort, teamLimit), "warn");
          return;
        }
        ensureTeams(teams.length + 1);
        renderStep2();
      });
    }

    // memberPickConfirm ボタンのイベント
    var confirmBtn = el("memberPickConfirm");
    if (confirmBtn) {
      confirmBtn.addEventListener("click", function () {
        if (!pickTarget) return;
        var added = 0;
        pickSelectedIds.forEach(function (pid) {
          assignments[pid] = assignValue(pickTarget);
          added++;
        });
        closeSheet("memberPickOverlay");
        renderStep2();
        if (added > 0) {
          showToast(
            window.Janreco.pluralize(i18n.addedCountTo, added)
              .replace('%{dest}', destInfo(pickTarget).name)
          );
        }
      });
    }

    // フォーム submit 前に sessionStorage をクリアし hidden input を構築
    var form = document.getElementById("assignment-form");
    if (form) {
      form.addEventListener("submit", function () {
        // submit 成功でリーグ詳細へ遷移するため、状態をクリア
        // 422等でサーバーバリデーション失敗の場合は状態が失われるが、
        // barNext は妥当時のみ有効化されるため送信自体は問題ない
        try {
          if (window.sessionStorage)
            window.sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
        buildHiddenInputs();
      });
    }

    renderStep2();
  }

  // ===== Turbolinks ライフサイクル =====
  document.addEventListener("turbolinks:load", function () {
    init();
  });

  document.addEventListener("turbolinks:before-cache", function () {
    // トースト状態をリセット
    var toast = el("toast");
    if (toast) toast.classList.remove("show");

    // シートを閉じる
    ["teamChoiceOverlay", "memberPickOverlay"].forEach(function (id) {
      var overlay = el(id);
      if (overlay) overlay.classList.remove("show");
    });

    // 動的コンテナをクリア
    var teamCardsEl = el("teamCards");
    if (teamCardsEl) teamCardsEl.innerHTML = "";
    var specialCardsEl = el("specialCards");
    if (specialCardsEl) specialCardsEl.innerHTML = "";
    var poolEl = el("poolChips");
    if (poolEl) poolEl.innerHTML = "";
  });
})();
